import Vue from 'vue'

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

Vue.component(
    'form-contactanos',
    require('../../componentes/sitio/FormularioContactanos.vue').default
)

Vue.config.productionTip = false
Vue.config.devtools = false

if (document.getElementById('vue-form-contactanos')) {
    new Vue({
        el: '#vue-form-contactanos'
    })
}
